import { isEmptyOrWhitespace } from "@shoothill/core";

export class StockListItemViewModel {
    // #region Properties

    public id: string = "";
    public description: string = "";
    public materialType: string = "";
    public materialSubType: string = "";
    public supplierCode: string = "";
    public unitOfMeasure: string = "";
    public stockQuantity: number = 0;
    public stockValue: number = 0;
    public canEditStock: boolean = false;

    // #endrgion Properties

    // #region Filtering

    public matchesFilter = (filterString: string): boolean => {
        if (isEmptyOrWhitespace(filterString)) {
            return true;
        }

        const filterStringUpperCase = filterString.toUpperCase();

        return this.description.toUpperCase().includes(filterStringUpperCase);
    };

    // #endregion Filtering
}
